var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-app',[_c('v-main',[_c('a-container',{staticClass:"m-light-gray"},[_c('v-row',{attrs:{"no-gutters":""}},[_c('v-col',{attrs:{"cols":"12","lg":"10","offset-lg":"1","xl":"8","offset-xl":"2"}},[_c('nuxt')],1)],1)],1)],1),_vm._v(" "),_c('a-snackbar')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }